import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function setActivePricingSection(section: string): RootActionTypes {
  return {
    type: ActionTypes.SET_ACTIVE_PRICING_SECTION,
    payload: section,
  };
}
